require("packs/link_tracker");
require("packs/bookmarks");
import { setEvents } from "packs/bookmarks";
import { fetchAPI } from "packs/api";

document.addEventListener("DOMContentLoaded", () => {
  // Show more deals and coupons button
  const viewAllCouponBtn = document.querySelector(".view-all-coupon");
  if (viewAllCouponBtn) {
    viewAllCouponBtn.addEventListener("click", function () {
      viewAllCouponBtn.parentNode.removeChild(viewAllCouponBtn);
      const moreCoupons = document.querySelector(".more-coupons");
      moreCoupons.classList.remove("hidden");
    });
  }

  const viewAllDealsBtn = document.querySelector(".view-all-deals");
  if (viewAllDealsBtn) {
    viewAllDealsBtn.addEventListener("click", function () {
      viewAllDealsBtn.parentNode.removeChild(viewAllDealsBtn);
      const moreDeals = document.querySelector(".more-deals");
      moreDeals.classList.remove("hidden");
    });
  }
  setEventsForCouponCards();
  function setEventsForCouponCards() {
    let toggleDescContent = function (elem, status) {
      let descOpenClose = elem;
      let descContent;
      if (status == "open") {
        descContent = descOpenClose.parentNode.nextElementSibling;
        descOpenClose.classList.toggle("hidden");
      } else if (status == "close") {
        descContent = descOpenClose.parentNode.parentNode;
        descContent.parentNode
          .querySelector(".desc-open-close")
          .classList.remove("hidden");
      }
      descContent.classList.toggle("hidden");
    };

    let descOpenCloseElements = document.querySelectorAll(".desc-open-close");
    descOpenCloseElements.forEach(function (elem) {
      elem.addEventListener("click", function () {
        toggleDescContent(this, "open");
      });
    });

    let descLess = document.querySelectorAll(".desc-less");
    descLess.forEach(function (elem) {
      elem.addEventListener("click", function () {
        toggleDescContent(this, "close");
      });
    });

    let shareIcons = document.querySelectorAll(".shareIcon");
    let closeDiv = document.querySelectorAll(".closediv");
    shareIcons.forEach(function (icon) {
      icon.addEventListener("click", function () {
        let popupMenu = this.nextElementSibling;
        popupMenu.classList.toggle("hidden");
      });
    });
    closeDiv.forEach(function (icon) {
      icon.addEventListener("click", function () {
        let popupMenu = this.parentNode;
        popupMenu.classList.toggle("hidden");
      });
    });
  }

  function changeCardView(view) {
    let currentUrl = new URL(window.location.href);
    let displayViewParam = "display_view";
    let displayViewValue = view;
    currentUrl.searchParams.set(displayViewParam, displayViewValue);
    window.location.href = currentUrl;
  }
  document.querySelectorAll(".change-display-view").forEach((display) => {
    display.addEventListener("click", function () {
      changeCardView(this.dataset.view);
    });
  });

  document
    .querySelector(".search-filter-box")
    .addEventListener("click", function () {
      openFilterPopup();
    });

  function updateAndRedirect(newParams) {
    const url = new URL(window.location.href);
    const currentSearchParams = new URLSearchParams(url.search);
    const keyword = currentSearchParams.get("keyword");
    const search_list = currentSearchParams.get("search_list");
    currentSearchParams.forEach((_, key) => currentSearchParams.delete(key));
    for (const [key, value] of Object.entries(newParams)) {
      currentSearchParams.set(key, value);
    }
    if (keyword && !newParams.keyword) {
      currentSearchParams.set("keyword", keyword);
    }
    if (search_list && !newParams.search_list) {
      currentSearchParams.set("search_list", search_list);
    }
    url.search = currentSearchParams.toString();
    window.location.href = url.toString();
  }

  function openFilterPopup() {
    document.body.insertAdjacentHTML("beforeend", getModalContent());
    toggleModal(false);
    setEventsForFilters();
  }

  window.openFilterPopup = openFilterPopup;

  function toggleModal(isOpen) {
    let filterDrawer = document.getElementById("filters-drawer");
    let target = filterDrawer;
    let options = {
      placement: "bottom",
      backdrop: true,
      bodyScrolling: false,
      edge: false,
      edgeOffset: "",
      backdropClasses: "bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-[700]",
      onHide: () => {
        filterDrawer.style.transform = "translateY(100%)";
        setTimeout(() => {
          filterDrawer.style.display = "none";
          document.getElementById("filter-section-content").innerHTML = filterDrawer.innerHTML;
          filterDrawer.remove();
        }, 200);
      },
      onShow: () => {
        filterDrawer.style.display = "block";
        filterDrawer.style.transform = "translateY(0%)";
        applyFiltersFromURL();
      },
      onToggle: () => {},
    };
    let instanceOptions = {
      id: "filters-drawer",
      override: true,
    };
    let instance = new Drawer(target, options, instanceOptions);
    if (isOpen) {
      instance.hide();
    } else {
      instance.show();
    }
  }

  window.toggleModal = toggleModal;

  function getModalContent() {
    return `<div id="filters-drawer" style="display:none" class="fixed p-[12px] bottom-0 left-0 right-0 z-[800] w-full rounded-t-[20px] overflow-y-auto transition-transform bg-white dark:bg-background-dark translate-y-[100%] transition" tabindex="-1" aria-labelledby="drawer-bottom-label">
      ${getFilterContent()}
    </div>`;
  }

  function getFilterContent() {
    let content = document.getElementById("filter-section-content").innerHTML;
    document.getElementById("filter-section-content").innerHTML = "";
    return content;
  }

  function applyFiltersFromURL() {
    let inputs = document.querySelectorAll("#filters-drawer input, #filters-drawer select");
    let params = new URLSearchParams(window.location.search);
  
    inputs.forEach((input) => {
      if (input.type === "checkbox" || input.type === "radio") {
        if (input.name === "sort-by") {
          input.checked = input.value === params.get("sort_type");
        } else if (input.name === "date-range") {
          input.checked = input.value === params.get("date_range");
        } else if (input.id === "expire_check_box") {
          input.checked = params.get("workflow_state") === "expire";
        } else if (input.id === "advanced_checkbox") {
          input.checked = params.get("advanced") === "true";
        } else if (input.id === "title_checkbox" || input.id === "description_checkbox" || input.id === "comments_checkbox") {
          let searchTerms = params.get("search_terms")?.split(",") || [];
          let value = input.getAttribute("onchange").split("'")[5];
          input.checked = searchTerms.includes(value);
          console.log(`Checkbox ${input.id}:`, input.checked);
        }
      } else if (input.tagName === "SELECT") {
        input.value = params.get(input.name) || "";
      }
    });
  }
  
  function setEventsForFilters() {
    function toggleCheckBox(id, paramKey, paramValue) {
      var check_box = document.getElementById(id);
      var url = new URL(window.location.href);
      var params = url.searchParams;
      var checked = !check_box.checked;
      if (checked) {
        check_box.checked = false;
        if (id === "expire_check_box") {
          params.delete("workflow_state");
        } else if (id === "search_in_description_checkbox") {
          if (params.get("search_terms") === "title_and_comments") {
            params.delete("search_terms");
          }
        } else if (paramKey === "search_terms") {
          let values = (params.get("search_terms") || "")
            .split(",")
            .filter(Boolean);
          values = values.filter((value) => value !== paramValue);
          if (values.length > 0) {
            params.set("search_terms", values.join(","));
          } else {
            params.delete("search_terms");
          }
        } else {
          params.delete(paramKey);
        }
      } else {
        check_box.checked = true;
        if (id === "expire_check_box") {
          params.set("workflow_state", "expire");
        } else if (id === "search_in_description_checkbox") {
          params.set("search_terms", "title_and_comments");
        } else if (paramKey === "search_terms") {
          let values = (params.get("search_terms") || "").split(",");
          if (!values.includes(paramValue)) {
            values.push(paramValue);
          }
          params.set("search_terms", values.join(","));
        } else {
          params.set(paramKey, paramValue);
        }
      }
    
      url.searchParams.set("page", 1);
    
      // Call setFilters() instead of reloading the page
      setFilters(params);
    }
  
    function addRadioChangeListener(name, callback) {
      document.querySelectorAll(`input[name="${name}"]`).forEach((radio) => {
        radio.addEventListener("change", function () {
          if (this.checked) {
            callback(this.value);
          }
        });
      });
    }
  
    addRadioChangeListener("date-range", updateDateRangeParam);
    addRadioChangeListener("sort-by", updateSortTypeParam);
  
    function updateQueryParam(param, selectedValue) {
      const url = new URL(window.location.href);
      url.searchParams.set(param, selectedValue);
      url.searchParams.set("page", 1);
  
      // Call setFilters() instead of reloading the page
      setFilters(url.searchParams);
    }
  
    function updateDateRangeParam(selectedValue) {
      updateQueryParam("date_range", selectedValue);
    }
  
    function updateSortTypeParam(selectedValue) {
      updateQueryParam("sort_type", selectedValue);
    }
  
    window.toggleCheckBox = toggleCheckBox;

    function areObjectsEqual(obj1, obj2) {
      const sortedObj1 = Object.keys(obj1)
        .filter((key) => (key !== "page" && key !== "search_list" && key !== "keyword")) // Remove "page" param
        .sort()
        .reduce((acc, key) => {
          acc[key] = obj1[key];
          return acc;
        }, {});
    
      const sortedObj2 = Object.keys(obj2)
        .filter((key) => (key !== "page" && key !== "search_list" && key !== "keyword")) // Remove "page" param
        .sort()
        .reduce((acc, key) => {
          acc[key] = obj2[key];
          return acc;
        }, {});
    
      return JSON.stringify(sortedObj1) === JSON.stringify(sortedObj2);
    }
  
    function setFilters(params) {
      document.getElementById("filter-section-form").style.pointerEvents = "none";
      document.querySelector(".loading-filters-complete").classList.add("hidden");
      document.querySelector(".loading-filters-ongoing").classList.remove("hidden");
      fetchAPI("/search_result", "GET", Object.fromEntries(params), "script").then(response => {
        document.getElementById("filter-section-form").style.pointerEvents = "";
        document.querySelector(".loading-filters-complete").classList.remove("hidden");
        document.querySelector(".loading-filters-ongoing").classList.add("hidden");
        const newUrl = new URL(window.location.href);
        newUrl.search = new URLSearchParams(params).toString();
        history.pushState({ path: newUrl.href }, "", newUrl.href);
        setEvents();
        couponCodeCopy();
        // Re-initialize link tracking and coupon click for dynamically loaded content
        if (typeof initLinkTracking === 'function') initLinkTracking();
        if (typeof couponClick === 'function') couponClick();
        // Define the target URL parameters
        const targetParamsObj = {
          keyword: "deal",
          search_list: "deals",
          workflow_state: "expire",
          search_terms: window.appconfig.default_search_terms,
          ref: "most_searched",
          date_range: "all_time",
          sort_type: "new",
        };

        // Convert params to object
        const currentParams = Object.fromEntries(params);

        // Compare the objects
        if (areObjectsEqual(currentParams, targetParamsObj)) {
          document.getElementById("filter-applied-icon").classList.add("hidden");
        } else {
          document.getElementById("filter-applied-icon").classList.remove("hidden");
        }
      }).catch(error => {});
    }

    document.querySelectorAll(".reset-filter").forEach((filter) => {
      filter.addEventListener("click", function () {
        let urlParams = new URLSearchParams(window.location.search);
        let searchListFromUrl = urlParams.get('search_list')
        let newParams = {
          search_list: searchListFromUrl,
          workflow_state: "expire",
          search_terms: window.appconfig.default_search_terms,
          ref: "most_searched",
          date_range: "all_time",
          sort_type: "new",
        };
        updateAndRedirect(newParams);
      });
    });
  }

  setEventsForFilters();
});

